import styled from "styled-components";

export const MatrixContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  @media(max-width: 900px) {
    display: block;
  }
`;

export const ExternalTitleWrapper = styled.div`
  display:flex;
  flex-wrap: wrap;
  @media(max-width: 900px) {
    display: none;
  }

  &.vertical{
    flex-direction:column;
    >div{
      width: 30px;
      height:100%;
      
      >div{
        transform: scale(-1); 
        writing-mode: vertical-lr;
        margin-top: 30px;
      }
    }
  }

  &.horizontal{
    width:100%;
    margin-left:30px;

    >div{
      height: 30px;
      width: 100%;
    }
  }
`;

export const ExternalContainerTitle = styled.div`
  display: flex;
  flex: 0 0 50%;
  flex-wrap: wrap;
  background-color: var(--grey);
  color: #fff;
  position: relative;
`;

export const ExternalTitle = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  font-size: 0.90rem;
`;

export const Wrapper = styled.div`
  flex: 0 0 calc(100% - 30px);
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  position: relative;
  font-size: 0.83rem;
  @media(max-width: 900px) {
    flex-direction: column;
    flex: 0 0 100%;
  }
`;

export const WrapQuadrant = styled.div`
  flex: 0 0 50%;
  border: 1px solid var(--border-color);
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  user-select: none;
`;

export const WrapTitle = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 30px;
  background-color: ${(props) => props.color ?? "white"};
  border-color: ${(props) => props.color ?? "white"};
  color: #fff;
  position: relative;
`;

export const WrapPanel = styled.div`
  flex: 0 0 calc(100% - 30px);
  width: calc(100% - 30px);
  border: 0;
  border-radius: 1px;
`;

export const PanelHeading = styled.div`
  padding-left: 5px;
  padding-right: 5px;
  font-weight: 400;
  padding-top: 0;
  font-size: 15px;
  font-weight: 300;
  border-bottom: 1px solid var(--border-color);
  border-top-right-radius: 1px;
  border-top-left-radius: 1px;
  height: fit-content;
  line-height: 2em;
`;

export const PanelContent = styled.div`
  display: flex;
  flex-direction: column;
  height: 35vh;
  overflow-x: hidden;
  overflow-y: auto;
  padding: 0 !important;
  border: 0;
`;

export const WrapTitleQuadrant = styled.div`
  transform: scale(-1); 
  writing-mode: vertical-lr;
  margin-top: 30px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const StyledFieldset = styled.fieldset`
  position: relative;
	width: 100%;
	border-radius: 8px;
	border: 1px solid var(--border-color);
	padding: 0px;
	display: flex;
`;

export const DivWithMarginBottom = styled.div`
	width: 100%;
	margin-bottom: 1.5rem;
  height: 35vh;
  overflow-x: auto;
`;

export const WrapNewActions =  styled.div<{filtersOpen :boolean}>`

  width: 100%;
  display: flex;
  height:  ${(props) => props.filtersOpen ? "35vh": "70vh"};
  overflow-y: scroll;
  overflow-x: hidden;

  @media(max-width: 600px){
    height: 35vh
  }
`;

export const Container = styled.div`
  display: flex;
  width: 100%;
  cursor: move;
  user-select: none;
`;
